var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-8 col-md-12"},[_c('div',{staticClass:"row mt-2 mb-5 pb-3 mx-2"},[_c('div',{staticClass:"card card-body mb-5"},[_c('h2',{staticClass:"font-weight-bold mt-3"},[_c('strong',[_vm._v("Our Partners")])]),_c('hr',{staticClass:"red title-hr"}),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("Site Under Construction")])])])])
}]

export { render, staticRenderFns }